import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import avatar from "../../assets/images/avatar.webp";
import formatDate from "./dateUtils";
import { useLeaveManagementStore } from "../../store/useLeaveManagementStore";

const LeaveDisplayCard = ({ selectedCompany, updateTotalLeaveRequest }) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const navigate = useNavigate();
  const loggedEmployeeId = userData.user[0]?.employee_id;
  const { attendanceData, getEmployeeLeaveData } = useLeaveManagementStore();

  useEffect(() => {
    // Default: last 30 days
    const today = new Date();
    const oneHundredEightyDaysAgo = new Date();
    oneHundredEightyDaysAgo.setDate(today.getDate() - 180);

    const start = oneHundredEightyDaysAgo.toISOString().split("T")[0]; // YYYY-MM-DD
    const end = today.toISOString().split("T")[0];

    getEmployeeLeaveData(start, end, navigate);
  }, [selectedCompany, navigate]); // ← add navigate to deps if you want

  useEffect(() => {
    const TotalLeaveRequest = attendanceData.length;
    updateTotalLeaveRequest(TotalLeaveRequest);
  }, [attendanceData, updateTotalLeaveRequest]);

  const getStatusColor = (employee) => {
    const currentManager = employee?.approving_managers_status?.find(
      (manager) => manager.emp_id === loggedEmployeeId,
    );

    if (currentManager) {
      switch (currentManager.status) {
        case "Approved":
          return "green";
        case "Rejected":
          return "red";
        case "Approved & Forwarded":
          return "gold";
        default:
          return "orange"; // Pending or unknown
      }
    }

    const { is_hr_approved, is_approved } = employee;

    if (is_hr_approved === 1 || is_approved === 1) {
      return "green";
    } else if (is_hr_approved === 0 || is_approved === 0) {
      return "red";
    } else if (is_hr_approved === 3 || is_approved === 3) {
      return "gold";
    } else {
      return "orange"; // Pending or unprocessed
    }
  };

  const getStatusText = (employee) => {
    // console.log("Get Status Text Employee", employee);

    const currentManager = employee?.approving_managers_status?.find(
      (manager) => manager.emp_id === loggedEmployeeId,
    );

    // console.log("Get Status Text Current Manager", currentManager);

    if (!currentManager) {
      const { is_hr_approved, is_approved } = employee;

      if (is_hr_approved === 1 || is_approved === 1) {
        return "Approved";
      } else if (is_hr_approved === 0 || is_approved === 0) {
        return "Declined";
      } else if (is_hr_approved === 3 || is_approved === 3) {
        return "Forwarded";
      } else {
        return "Pending";
      }
    }

    switch (currentManager.status) {
      case "Approved":
        return "Approved";
      case "Rejected":
        return "Rejected";
      case "Approved & Forwarded":
        return "Approved & Forwarded";
      default:
        return "Pending";
    }
  };

  return (
    <div className="leave__display-container">
      {[...attendanceData]
        .sort((a, b) => new Date(b.leave_from) - new Date(a.leave_from))
        .map((employee, index) => (
          <div
            key={index}
            className="display__section"
            onClick={() => navigate("/leavemanagement")}
          >
            <div className="personal__section">
              <div className="employee__img">
                <img
                  src={
                    employee.user.profile_picture
                      ? employee.user.profile_picture
                      : avatar
                  }
                  alt="employee"
                />
              </div>
              <div className="emp__details">
                <h6>{employee.user.employee_full_name}</h6>
                <p>{formatDate(employee.leave_from)}</p>
                <p>{formatDate(employee.leave_to)}</p>
              </div>
            </div>

            <div className="flex items-center justify-center gap-1">
              <span>
                <i
                  style={{ color: getStatusColor(employee), fontSize: "10px" }}
                  className="fa-solid fa-circle"
                ></i>
              </span>
              <span
                style={{
                  color: getStatusColor(employee),
                  fontSize: "10px",
                  marginTop: "4px",
                }}
              >
                {getStatusText(employee)}
              </span>
            </div>
          </div>
        ))}
    </div>
  );
};

export default LeaveDisplayCard;
